/** Server response error code that indicates duplicate cancellation attempt */
export const DUPLICATE_DEAL_CANCELLATION_ERROR_CODE = 409